'use client';
import { createContext } from 'react';
const DatadogRumContext = createContext(null);
export default DatadogRumContext;
//# sourceMappingURL=datadog-rum.js.map